import { mediaUrl } from './BlockRenderer';
import type { CustomPage } from '../../lib/types';

export function formatPostDate(value: string | null) {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
}

export function PostList({ posts }: { posts: CustomPage[] }) {
  return (
    <div className="post-list">
      {posts.map((post) => (
        <article className="post-card" key={post.id}>
          {post.heroImageId && <img src={mediaUrl(post.heroImageId)} alt="" loading="lazy" />}
          <p className="post-card__meta">{formatPostDate(post.publishedAt)}{post.category && ` · ${post.category}`}</p>
          <h2><a href={`/blog/${post.slug}`}>{post.title}</a></h2>
          <p>{post.summary}</p>
        </article>
      ))}
    </div>
  );
}
